import { ref } from 'vue'
import { MEDIAS } from '@/common/js/constants.js'
import { getToutiaoTargetingForm } from '../model/form.js'
import { getAccountById } from '@/api/ptom.data.model.js'
import { addTargeting, updateTargeting, getTargetingDataById } from '@/api/manage.model'
import { Message } from 'view-design'
import { AGE_TYPES, TOUTIAO_AD_MARKETING_SCENE } from '../model/toutiao_targeting_consts.js'
import { setLocal, getLocal } from '@/common/js/api.js'

// 编辑、复制记录类型  edit | copy
const editType = ref('')

const moreAges = [
  AGE_TYPES.AGE_BETWEEN_18_19,
  AGE_TYPES.AGE_BETWEEN_20_23,
  AGE_TYPES.AGE_BETWEEN_31_35,
  AGE_TYPES.AGE_BETWEEN_36_40,
  AGE_TYPES.AGE_BETWEEN_41_45,
  AGE_TYPES.AGE_BETWEEN_46_50,
  AGE_TYPES.AGE_BETWEEN_51_55,
  AGE_TYPES.AGE_BETWEEN_56_59,
  AGE_TYPES.AGE_ABOVE_60
]

/**
 * @description: 编辑定向，更新提交
 */
export function useTargetingFormEdit(targetingFormRef) {
  const initFormEdit = async (id, edittype) => {
    editType.value = edittype
    try {
      const data = await getTargetingDataById({ targetingId: id })
      const { targetingParamJson, accountIds, targetingName, targetingDesc } = data
      const accountInfo = await getAccountById({ ad_account_id: Number(accountIds) })
      const { age } = targetingParamJson
      let isMoreAge = false
      age.map((ag) => {
        if (moreAges.includes(ag)) {
          isMoreAge = true
        }
      })
      const targetingForm = {
        ...targetingParamJson,
        ad_marketing_scene: targetingParamJson.ad_marketing_scene || TOUTIAO_AD_MARKETING_SCENE.VERSION_2,
        targetingId: id,
        account: {
          name: accountInfo.adAccount,
          id: accountInfo.id
        },
        name: targetingName,
        description: targetingDesc,
        age: isMoreAge ? [AGE_TYPES.MORE] : age,
        moreAge: isMoreAge ? age : []
      }

      targetingFormRef.value.setForm(targetingForm)
      return Promise.resolve()
    } catch (e) {
      return Promise.reject(new Error('获取定向信息失败'))
    }
  }

  return {
    initFormEdit
  }
}

/**
 * @description: 提交定向包
 */
export function useTargetingFormSubmit(router, getInitForm) {
  const submitLoading = ref(false)
  const targetingFormRef = ref(null)

  const formValidator = async (done) => {
    try {
      await targetingFormRef.value.validate()
      done && done()
      return Promise.resolve()
    } catch (e) {
      return Promise.reject(new Error('targetingFormRef validate error'))
    }
  }

  const onFormSubmit = async () => {
    if (submitLoading.value) return
    try {
      await formValidator()
      const targetingForm = targetingFormRef.value.getForm()
      const { account, name, description, targetingId, ...restTargetingParams } = targetingForm
      if (restTargetingParams.age.toString() === AGE_TYPES.MORE) {
        restTargetingParams.age = restTargetingParams.moreAge
      }

      // 保存账号选择到本地缓存，下次新建定向回显
      if (account?.id) {
        setLocal('targetingFormAccount', account)
      }
      const params = {
        mediaId: MEDIAS.TOUTIAO,
        accountIds: account.id,
        targetingName: name,
        targetingDesc: description,
        targetingParam: JSON.stringify(restTargetingParams)
      }
      submitLoading.value = true
      ;(targetingId && editType.value === 'edit' ? updateTargeting({ targetingId, ...params }) : addTargeting(params))
        .then((data) => {
          if (router) {
            if (data) {
              Message.success({
                closable: true,
                duration: 2,
                content: '提交成功！2秒后自动跳转'
              })
              setTimeout(onFormCancel, 2000)
            }
          } else {
            onFormCancel()
          }

          return Promise.resolve()
        })
        .catch(() => {
          submitLoading.value = false
          return Promise.reject(new Error())
        })
    } catch (e) {
      console.log(' targeting submit error output: ', e)
    }
  }

  const onFormCancel = () => {
    submitLoading.value = false
    editType.value = ''

    if (getInitForm) {
      targetingFormRef.value.setForm(getInitForm())
    }
    router && router.replace({ name: 'targetingslist' })
  }
  return {
    targetingFormRef,
    submitLoading,
    formValidator,
    onFormSubmit,
    onFormCancel
  }
}
